// Copyright (c) 2017 Deere & Company

import DebitOtherCreditPanel from './debit-other-credit-panel';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    adjustmentTypes: state.tcsm.partialDebit.adjustmentTypes.filter(adjustmentType => adjustmentType.key !== '04'),
    credits: state.tcsm.partialDebit.debit.getOtherCredits(),
    isEditable: true
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const {updateAdjustmentType, updateAdjustmentValue} = dispatchProps;

    return {
        ...stateProps,
        actions: {
            updateAdjustmentType,
            updateAdjustmentValue
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(DebitOtherCreditPanel);



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/debit-other-credits-panel/index.js